import { MetaDefinition } from '@angular/platform-browser';
import { formatUrl, isUrl, SeoConfig } from '@common';

export function formatMetaTags(
  data: unknown,
  property?: string,
): MetaDefinition[] {
  if (Array.isArray(data)) {
    return data.map((child) => formatMetaTags(child, property)).flat();
  }

  if (typeof data === 'object' && data !== null) {
    return Object.entries(data as Record<string, unknown>).reduce(
      (metaDefinitions: MetaDefinition[], [key, value]) => {
        const metaDefinitionProperty = property ? `${property}:${key}` : key;

        return [
          ...metaDefinitions,
          ...formatMetaTags(value, metaDefinitionProperty),
        ];
      },
      [],
    );
  }

  if (data && property) {
    return [
      {
        content: String(data),
        name: property,
        property,
      },
    ];
  }

  return [];
}

export function formatMetaTagsAbsoluteUrl(
  metaTags: MetaDefinition[],
  config: SeoConfig,
): MetaDefinition[] {
  const absoluteUrlMetaTagKeys: string[] = [
    'og:audio',
    'og:image',
    'og:image:url',
    'og:image:secure_url',
    'og:video',
    'og:video:url',
    'og:video:secure_url',
  ];

  return metaTags.map((metaTag: MetaDefinition) => {
    if (
      !metaTag.content ||
      !metaTag.property ||
      !absoluteUrlMetaTagKeys.includes(metaTag.property)
    ) {
      return metaTag;
    }

    if (isUrl(metaTag.content)) {
      return metaTag;
    }

    return {
      ...metaTag,
      content: formatUrl(`${config.hostUrl}/${metaTag.content}`),
    };
  });
}
